// find a matching string in an array json string keys, and return the index
export const getKeysIndex = (keysArray: string[], matchingJsonString: string): number => {
  const idx = keysArray.findIndex(metalsString => metalsString === matchingJsonString);
  return idx === -1 ? 0 : idx;
};
